import { createRouter, createWebHistory } from 'vue-router'
import ContentGenerator from './ContentGenerator.vue'
import ToolForm from "@/app/tool-app/ToolForm.vue";
import SignIn from "@/app/views/SignIn.vue";
import SignUp from "@/app/views/SignUp.vue";

const router = createRouter({
  history: createWebHistory('/'),
  routes: [
    {
        path: '/tool-app',
        redirect: '/tool-app/new-tool',
    },
    {
      path: '/tool-app/new-tool',
      name: 'new-tool',
      component: ToolForm
    },
    {
      path: '/tool-app/edit-tool/:id',
      name: 'edit-tool',
      component: ToolForm
    },
    {
      path: '/tool-app/:id',
      name: 'tool-app',
      component: ContentGenerator
    },
    {
      path: '/tool-app/sign-in',
      name: 'sign-in',
      component: SignIn
    },
    {
      path: '/tool-app/sign-up',
      name: 'sign-up',
      component: SignUp
    }
  ]
})

export default router
